module.exports = __webpack_public_path__ + "img/valve-16-23-45.0b990755.svg";